import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1ef73b00"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 添加 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 删除 ");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("关闭");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存");

const _hoisted_5 = ["src"];
import { computed, watch, ref, reactive } from 'vue';
import { useStore } from 'vuex';
import { getVexTableProps } from '@/config';
import AddTeamModal from '@/components/AddTeamModal.vue';
import { uploadFile } from '@/request/api';
import { saveVoteActivity } from '@/request';
import { ElMessage } from 'element-plus';
export default {
  name: 'SaveVoteActivityModal',
  props: {
    editData: {
      type: [null, Object],
      default: null
    },
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const showImgModal = ref(false);
    const showImgUrl = ref('');
    const disabled = computed(() => props.editData && props.editData.activityStatus !== 1);
    const title = computed(() => {
      if (disabled.value) {
        return '查看活动';
      }

      return props.editData ? '编辑活动' : '新增评选竞赛活动';
    });
    const tableOptions = getVexTableProps({
      toolbarConfig: null,
      size: 'mini',
      columns: [{
        title: '团队名称',
        field: 'supplier_name'
      }, {
        title: '操作',
        width: '100px',
        fixed: 'right',
        slots: {
          default: 'operation'
        }
      }],
      pagerConfig: null
    });

    function previewImg(file) {
      showImgUrl.value = file.url;
      showImgModal.value = true;
    }

    const showAddSupplierModal = ref(false);
    const selectedIds = computed(() => form.value.supplier.map(item => item.supplier_id));
    const form = ref({
      time: [],
      supplier: [],
      exampleList: [],
      shareList: [],
      activityLink: []
    });
    const formRef = ref(); // const activityTimeDisabledDate = (date) => {
    //   let oneDayTimeStamp = 24 * 60 * 60 * 1000;
    //   return new Date(date).getTime() + oneDayTimeStamp < Date.now();
    // };

    const option = {
      name: 'file',
      action: uploadFile.url
    };

    function beforeUpload(file) {
      if (file.size / 1024 / 1024 > 1) {
        ElMessage.error('文件大小不可超过 1MB!');
        return false;
      }

      if (!/.(jp(e)?g|png)$/i.test(file.name)) {
        ElMessage.error('上传文件必须是 jpg,jpeg,png格式的文件');
        return false;
      }

      return true;
    }

    function shareBeforeUpload(file) {
      if (file.size / 1024 / 1024 > 1) {
        ElMessage.error('文件大小不可超过 1MB!');
        return false;
      }

      if (!/.(jp(e)?g|png)$/i.test(file.name)) {
        ElMessage.error('上传文件必须是 jpg,jpeg,png格式的文件');
        return false;
      }

      return true;
    }

    watch(() => props.modelValue, newVal => {
      if (newVal && props.editData) {
        form.value = _objectSpread(_objectSpread({
          time: [props.editData.activityStartTime, props.editData.activityEndTime],
          exampleList: props.editData.examplePictureList.map(i => ({
            name: Date.now(),
            url: i
          })),
          shareList: [{
            name: Date.now(),
            url: props.editData.sharePicture
          }],
          supplier: props.editData.supplierList.map(i => ({
            supplier_id: i.supplierId,
            supplier_name: i.supplierName
          }))
        }, props.editData), {}, {
          activityLink: [{
            name: Date.now(),
            url: props.editData.activityLink
          }]
        });
      } else {
        var _formRef$value;

        form.value = {
          time: [],
          supplier: [],
          exampleList: [],
          shareList: [],
          activityLink: []
        };
        (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.resetFields();
      }
    });

    function onSuccess(data) {
      if (data.code === 1) {
        form.value.exampleList = form.value.exampleList.map(file => {
          if (file.response) {
            file.url = file.response.data.picUrl;
          }

          return file;
        });
      } else {
        form.value.exampleList = form.value.exampleList.filter(file => {
          if (file.response && file.response.code === 1) {
            return true;
          }

          if (!file.response) {
            return true;
          }

          return false;
        });
      }
    }

    function onShareSuccess(data) {
      if (data.code === 1) {
        data.url = data.data.picUrl;
        form.value.shareList = [{
          name: Date.now(),
          url: data.data.picUrl
        }];
      } else {
        form.value.shareList = [];
      }
    }

    function avtivityBeforeUpload(file) {
      if (file.size / 1024 / 1024 > 1) {
        ElMessage.error('文件大小不可超过 2MB!');
        return false;
      }

      if (!/.(jp(e)?g|png)$/i.test(file.name)) {
        ElMessage.error('上传文件必须是 jpg,jpeg,png格式的文件');
        return false;
      }

      return true;
    }

    function avtivitySuccess(data) {
      if (data.code === 1) {
        data.url = data.data.picUrl;
        form.value.activityLink = [{
          name: Date.now(),
          url: data.data.picUrl
        }];
      } else {
        form.value.activityLink = [];
      }
    }

    function addSupplierSuccess(rows) {
      form.value.supplier = form.value.supplier.concat(rows);
    }

    function delSupplier(sup) {
      form.value.supplier = form.value.supplier.filter(i => i.supplier_id !== sup.supplier_id);
    }

    function save() {
      formRef.value.validate(e => {
        if (e) {
          saveVoteActivity({
            voteId: form.value.voteId,
            activityName: form.value.activityName,
            activityIntroduction: form.value.activityIntroduction,
            activityStartTime: form.value.time[0],
            activityEndTime: form.value.time[1],
            activityLink: form.value.activityLink[0].url,
            examplePictureList: form.value.exampleList.map(i => i.url),
            sharePicture: form.value.shareList[0].url,
            supplierIdList: form.value.supplier.map(i => i.supplier_id),
            __warn: true,
            __repeat: true
          }).then(data => {
            if (data.success) {
              ElMessage.success('保存成功');
              emit('success');
              visible.value = false;
            }
          });
        }
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_Plus = _resolveComponent("Plus");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_upload = _resolveComponent("el-upload");

      const _component_el_alert = _resolveComponent("el-alert");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _isRef(visible) ? visible.value = $event : null),
        title: _unref(title),
        width: "650px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "default",
          onClick: _cache[7] || (_cache[7] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), !_unref(disabled) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form.value,
          ref_key: "formRef",
          ref: formRef,
          disabled: _unref(disabled)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "活动名称:",
            prop: "activityName",
            rules: [{
              required: true,
              message: '请输入活动名称'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.activityName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.activityName = $event),
              placeholder: "请输入活动名称",
              maxLength: "16"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "活动介绍:",
            prop: "activityIntroduction",
            rules: [{
              required: true,
              message: '请输入活动介绍'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              modelValue: form.value.activityIntroduction,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.activityIntroduction = $event),
              placeholder: "请输入活动介绍",
              maxLength: "69"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "活动时间:",
            prop: "time",
            rules: [{
              required: true,
              message: '请选择活动时间'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: form.value.time,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.time = $event),
              "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 2, 1, 23, 59, 59)],
              type: "datetimerange",
              "range-separator": "至",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间",
              "value-format": "YYYY-MM-DD HH:mm:ss"
            }, null, 8, ["modelValue", "default-time"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "活动说明图片:",
            prop: "activityLink",
            rules: [{
              required: true,
              message: '请上传活动说明图片'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              action: option.action,
              multiple: false,
              data: option.data,
              name: option.name,
              class: _normalizeClass({
                upload: form.value.activityLink.length > 0
              }),
              limit: 1,
              "before-upload": avtivityBeforeUpload,
              "on-preview": previewImg,
              "on-success": avtivitySuccess,
              "list-type": "picture-card",
              "file-list": form.value.activityLink,
              "onUpdate:file-list": _cache[3] || (_cache[3] = $event => form.value.activityLink = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_component_Plus)]),
                _: 1
              })]),
              _: 1
            }, 8, ["action", "data", "name", "class", "file-list"]), _createVNode(_component_el_alert, {
              style: {
                "margin-top": "10px"
              },
              title: "图片大小不可超过2MB, 图片格式为jpg,jpeg,png",
              type: "warning"
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "活动报名示例图",
            prop: "exampleList",
            rules: [{
              required: true,
              message: '请上传示例图片'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              action: option.action,
              multiple: false,
              data: option.data,
              name: option.name,
              class: _normalizeClass({
                upload: form.value.exampleList.length > 2
              }),
              limit: 3,
              "before-upload": beforeUpload,
              "on-preview": previewImg,
              "on-success": onSuccess,
              "list-type": "picture-card",
              "file-list": form.value.exampleList,
              "onUpdate:file-list": _cache[4] || (_cache[4] = $event => form.value.exampleList = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_component_Plus)]),
                _: 1
              })]),
              _: 1
            }, 8, ["action", "data", "name", "class", "file-list"]), _createVNode(_component_el_alert, {
              style: {
                "margin-top": "10px"
              },
              title: "图片大小不可超过1MB, 图片格式为jpg,jpeg,png, 建议图片尺寸 200 * 200",
              type: "warning"
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "推广卡片图片",
            prop: "shareList",
            rules: [{
              required: true,
              message: '请上传推广卡片图片'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              action: option.action,
              multiple: false,
              data: option.data,
              name: option.name,
              "before-upload": shareBeforeUpload,
              "on-success": onShareSuccess,
              "on-preview": previewImg,
              "list-type": "picture-card",
              "file-list": form.value.shareList,
              "onUpdate:file-list": _cache[5] || (_cache[5] = $event => form.value.shareList = $event),
              class: _normalizeClass({
                upload: form.value.shareList.length > 0
              })
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_component_Plus)]),
                _: 1
              })]),
              _: 1
            }, 8, ["action", "data", "name", "file-list", "class"]), _createVNode(_component_el_alert, {
              style: {
                "margin-top": "10px"
              },
              title: "图片大小不可超过1MB, 图片格式为jpg,jpeg,png, 建议图片尺寸 400 * 360",
              type: "warning"
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "发起团队",
            prop: "supplier",
            rules: [{
              required: true,
              message: '请选择发起团队'
            }]
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_button, {
              type: "primary",
              icon: "Plus",
              onClick: _cache[6] || (_cache[6] = $event => showAddSupplierModal.value = true)
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            })])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
              data: form.value.supplier,
              style: {
                "width": "500px",
                "margin-left": "70px"
              }
            }), {
              operation: _withCtx(({
                row
              }) => [_createVNode(_component_el_button, {
                type: "danger",
                icon: "Delete",
                size: "small",
                onClick: $event => delSupplier(row)
              }, {
                default: _withCtx(() => [_hoisted_2]),
                _: 2
              }, 1032, ["onClick"])]),
              _: 1
            }, 16, ["data"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "disabled"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(AddTeamModal, {
        "selected-ids": _unref(selectedIds),
        businessCategory: "2",
        modelValue: showAddSupplierModal.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => showAddSupplierModal.value = $event),
        onSuccess: addSupplierSuccess
      }, null, 8, ["selected-ids", "modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: showImgModal.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => showImgModal.value = $event),
        width: "600px"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: showImgUrl.value,
          style: {
            "width": "100%"
          },
          alt: "Preview Image"
        }, null, 8, _hoisted_5)]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }

};